import * as svg from "../../../assets/pet.svg";

import {iconBuilder} from "./iconBuilder";

const PawIcon = iconBuilder(svg, "PawIcon", "0 0 24 24");

export default PawIcon;
